
import { apiCall } from "../../service/api-service.js";

export const getAssetListApi = async (queryString) =>
  apiCall("get", `asset?${queryString}`, null, {});

export const getValidateScanDataApi = async (qrTag) => 
  apiCall("post", "dock_scan", { code: qrTag });

export const getAssetTagApi = async (type) => 
  apiCall("post", "asset/tag_autogen", { type });

export const createAssetApi = async (data) => 
  apiCall("post", "asset", data);

export const updateAssetApi = async (id, data) => 
  apiCall("put", `asset/${id}`, data);

export const getAssetApi = async (id) => 
  apiCall("get", `asset/edit/${id}`);

export const validateRemainderApi = async (data) => 
  apiCall("post", "reminder_validation", data);

export const uploadProfileAttachmentApi = async (id, data) => 
  apiCall("post", `asset/profile/${id}`, data);

export const uploadAttachmentApi = async (id, data) => 
  apiCall("post", `asset/attachment/${id}`, data);

export const getAssetProfileApi = async (id) => 
  apiCall("get", `asset/profile/${id}`);

export const getAssetAttachmentApi = async (id) => 
  apiCall("get", `asset/attachment/${id}`);

export const getAssetReminderApi = async (id) => 
  apiCall("get", `reminder/${id}`);

export const getAssetInfoApi = async (tag) => 
  apiCall("get", "get_asset", null, { params: { asset_tag: tag } });

export const submitAssetCheckingApi = async (data) => 
  apiCall("post", "checking", data);

export const getDeleteApi = async (deleteUrl) => 
  apiCall("delete", deleteUrl);

export const bulkDeleteApi = async (deleteUrl, ids) => 
  apiCall("delete", deleteUrl, { id: ids });

export const createReminderApi = async (data) => 
  apiCall("post", "reminder", data);

export const updateReminderApi = async (id, data) => 
  apiCall("put", `reminder/${id}`, data);

export const uploadAssetApi = async (data) => {
  const response = await apiCall("post", "asset_upload", data);
  const base64String = response?.data?.base64;

  if ((response?.status === 400 || response?.status === 500) && base64String) {
    const fileName = `Asset_Upload_Error${Date.now()}.xlsx`;
    const binary = atob(base64String);
    const bytes = [];
    for (let i = 0; i < binary.length; i++) {
      bytes.push(binary.charCodeAt(i));
    }

    const blob = new Blob([new Uint8Array(bytes)], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return response;
};

export const templateDownloadApi = async () => 
  apiCall("get", "template_download");

export const saveDataEntryApi = async (id, data) => 
  apiCall("post", `asset/date_entry/${id}`, data);

export const getReferenceApi = async (id) => 
  apiCall("get", `asset/reference/${id}`);
